export const sx = {
  root: {
    marginTop: 2,
    marginBottom: 2,
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  gridShootingDayItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  currentDate: {
    width: '100%',
  },
  crewInfo: {
    width: '100%',
  },
  titleContainer: {
    textAlign: 'center',
    width: '100%',
  },
}
